'use strict'
import { request } from '../../plugins/http'

export default async (data) => {
    return data.name 
        ? await request.get('/cliente',{params:{type: 'name', value: data}})
        : await request.get('/cliente',{params:{type: 'all'}})
}